import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "../AddTimeTable.css";
import Axios from "axios";
import { url } from "../../../../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../../Components/FormLoader/FormLoader";

class TimeTableForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editDataStatus: false,
      timeData: {
        subjectName: "",
        from: "",
        to: "",
        classTeacherName: "",
        classTeacherId: "",
      },
      error: {
        fromError: "",
        toError: "",
        classTeacherError: "",
      },
      staffList: [],
      showCancel: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.getTeacher();
  }

  getTeacher = async () => {
    try {
      const response = await Axios.get(`${url}/api/staffs`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.staffs.length !== 0) {
        this.setState({
          staffList: response.data.staffs,
        });
      } else {
        this.setState({
          staffList: [],
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getTeacher();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      weekName: e.target.value,
    });
  };

  handleChangeData = (e) => {
    this.setState({
      timeData: { ...this.state.timeData, [e.target.name]: e.target.value },
    });
  };

  handleChangeTeacherData = (e) => {
    let filterData = this.state.staffList.filter(
      (data) => data._id === e.target.value
    );
    this.setState({
      timeData: {
        ...this.state.timeData,
        classTeacherName: filterData[0].fullName,
        classTeacherId: e.target.value,
      },
    });
  };

  editChange = (data) => {
    this.setState({
      editDataStatus: true,
      showCancel: true,
      timeData: {
        subjectName: data.subjectName,
        from: data.from,
        to: data.to,
        classTeacherName: data.classTeacherName,
        classTeacherId: data.classTeacherId,
      },
    });
  };

  checkError = () => {
    let fromError = "";
    let toError = "";
    let classTeacherError = "";

    if (this.state.timeData.from === "") {
      fromError = "Please enter the time";
    }
    if (this.state.timeData.to === "") {
      toError = "Please enter the time";
    }

    if (
      this.state.timeData.classTeacherName === "" &&
      this.state.timeData.classTeacherId === ""
    ) {
      classTeacherError = "Class Teacher must be inserted";
    }

    if (fromError || toError || classTeacherError) {
      this.setState({
        error: {
          fromError,
          toError,
          classTeacherError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          fromError: "",
          toError: "",
          classTeacherError: "",
        },
      });
      return false;
    }
  };

  handleSubmit = () => {
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.setState({ loading: true });
      this.setState({ editDataStatus: false });
      this.props.handleAddSubject(this.state.timeData, this.props.data._id);
    }
  };

  render() {
    const { classes, index, data } = this.props;
    const { timeData } = this.state;
    const filteredTeacher = this.state.staffList.filter(
      (data) => data.department === "Teaching"
    );
    return this.state.editDataStatus === false ? (
      <TableRow key={index} style={{ width: "100%" }}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.subjectName}</TableCell>
        <TableCell align="center">{data.from ? data.from : "00:00"}</TableCell>
        <TableCell align="center">{data.to ? data.to : "00:00"}</TableCell>
        {data.classTeacherName ? (
          <TableCell align="center">{data.classTeacherName}</TableCell>
        ) : (
          <TableCell align="center" style={{ color: "red" }}>
            Teacher not added
          </TableCell>
        )}
        <TableCell align="center">
          <Tooltip
            arrow
            title="Edit"
            className={classes.tooltip}
            onClick={() => this.editChange(data)}
          >
            <EditIcon />
          </Tooltip>
        </TableCell>
      </TableRow>
    ) : (
      <TableRow key={index}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.subjectName}</TableCell>
        <TableCell align="center">
          <TextField
            name="from"
            type="time"
            required
            fullWidth
            variant="outlined"
            label="From"
            error={this.state.error.fromError ? true : false}
            helperText={this.state.error.fromError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={timeData.from}
            onChange={this.handleChangeData}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="to"
            type="time"
            required
            fullWidth
            variant="outlined"
            label="To"
            error={this.state.error.toError ? true : false}
            helperText={this.state.error.toError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={timeData.to}
            onChange={this.handleChangeData}
          />
        </TableCell>
        <TableCell align="center">
          <TextField
            name="classTeacherId"
            select
            required
            fullWidth
            variant="outlined"
            label="Class Teacher"
            error={this.state.error.classTeacherError ? true : false}
            helperText={this.state.error.classTeacherError}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={timeData.classTeacherId}
            onChange={this.handleChangeTeacherData}
          >
            <option value="">Select Any One</option>
            {filteredTeacher.map((teacher, index) => (
              <option key={index} value={teacher._id}>
                {teacher.fullName}
              </option>
            ))}
          </TextField>
        </TableCell>
        <TableCell align="center">
          <>
            <Tooltip
              arrow
              title="Update"
              className={classes.tooltip}
              onClick={this.handleSubmit}
            >
              <AddCircleIcon />
            </Tooltip>
            {this.state.showCancel && (
              <Tooltip
                arrow
                title="Cancel"
                className={classes.tooltip}
                onClick={() => this.setState({ editDataStatus: false })}
              >
                <CancelIcon />
              </Tooltip>
            )}
            <br />
            {this.state.loading && <FormLoader />}
          </>
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(TimeTableForm));
